import * as React from "react";
import type { SVGProps } from "react";
const SvgRotateCcw = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 4a1 1 0 0 0-2 0zm-1 6H0a1 1 0 0 0 1 1zm6 1a1 1 0 1 0 0-2zm-2.547 3.668a1 1 0 0 0-1.886.664zM5.64 5.64l.685.729.022-.021zM0 4v6h2V4zm1 7h6V9H1zm1.567 4.332a10 10 0 0 0 3.89 5.002l1.109-1.665a8 8 0 0 1-3.113-4.001zm3.89 5.002a10 10 0 0 0 6.116 1.659l-.115-1.997a8 8 0 0 1-4.892-1.327zm6.116 1.659a10 10 0 0 0 5.885-2.35l-1.292-1.527a8 8 0 0 1-4.708 1.88zm5.885-2.35a10 10 0 0 0 3.291-5.415l-1.95-.444a8 8 0 0 1-2.633 4.332zm3.291-5.415a10 10 0 0 0-.624-6.306L19.3 8.74a8 8 0 0 1 .5 5.044zm-.624-6.306a10 10 0 0 0-4.288-4.664l-.968 1.75A8 8 0 0 1 19.3 8.74zm-4.288-4.664a10 10 0 0 0-6.232-1.151l.279 1.98a8 8 0 0 1 4.985.921zm-6.232-1.151a10 10 0 0 0-5.672 2.825l1.414 1.416a8 8 0 0 1 4.537-2.26zM4.955 4.91l-4.64 4.36 1.37 1.458 4.64-4.36z"
    />
  </svg>
);
export default SvgRotateCcw;
